export interface IMechanic {
  id: number | string;
  uuid?: string;
  user_name?: string;
  name: string;
  contact_no?: string;
  mobile_number: string;
  nodal?: string;
  nodal_name: string;
  mechanic_shift?: string;
  shift?: string;
  mechanic_type?: string;
  type?: string;
  rsa_sow?: string;
  rsa_mechanic?: string;
  sow_mechanic?: string;
  towing_mechanic?: string;
  agreed_amount?: number | string;
  extra_amount?: number | string;
  created_by?: string;
  create_dt?: string;
  city?: string;
  state?: string;
  total_services_done?: number | string;
  total_earned_amount?: number | string;
  address?: string;
  pincode?: string;
  status?: string;
  created_at?: string;
  [key: string]: any;
}

export interface IUpsertMechanic {
  backoffice_users_id: number;
  username_v: string;
  email_id_v: string;
  password_v: string;
  branch_office_v: string;
  contact_no_v: string;
  mechanic_type_v: string;
  rsa_mechanic_v: string;
  sow_mechanic_v: string;
  towing_mechanic_v: string;
  mechanic_docs_v: {
    aadhar_front: string | null;
    aadhar_back: string | null;
    pan: string | null;
    DL: string | null;
    passbook: string | null;
    shop_photo: string | null;
    agreement: string | null;
  };
  state_v: string;
  city_v: string;
  location_v: string;
  address_v: string;
  pin_v: string;
  latitude_v: number;
  longitude_v: number;
  payout_type_v: string;
  nodal_v: string;
  agreed_amount_v: number | string;
  extra_amount_v: number | string;
  mechanic_shift_v: string;
  status_v: string;
}

export const defaultMechanic: IUpsertMechanic = {
  backoffice_users_id: 0,
  username_v: "",
  email_id_v: "",
  password_v: "",
  branch_office_v: "",
  contact_no_v: "",
  mechanic_type_v: "",
  rsa_mechanic_v: "",
  sow_mechanic_v: "",
  towing_mechanic_v: "",
  mechanic_docs_v: {
    aadhar_front: null,
    aadhar_back: null,
    pan: null,
    DL: null,
    passbook: null,
    shop_photo: null,
    agreement: null,
  },
  state_v: "",
  city_v: "",
  location_v: "",
  address_v: "",
  pin_v: "",
  latitude_v: 0,
  longitude_v: 0,
  payout_type_v: "",
  nodal_v: "",
  agreed_amount_v: 0,
  extra_amount_v: 0,
  mechanic_shift_v: "",
  status_v: "Active",
};

export const nodalNames = [
  "Other",
  "Nodal",
  "Amity",
  "Asharm",
  "Bus Adda",
  "Bypass",
  "Chattarpur",
  "Dwarka",
  "Ghaziabad",
  "IFFCO Chowk",
  "India gate",
  "Janakpuri",
  "Karol Bagh",
  "Libas pur",
  "Nanak piao",
  "Noida Sec-62",
  "Noida Sec. 18",
  "Patel Nagar",
  "Punjabi bagh",
  "Shastri Nagar",
  "Towing-Free",
];

export interface IGetMechanic {
  backoffice_users_id: number;
  user_name: string;
  email_id: string;
  role_id: number;
  hierarchy: number;
  entry_dt: string;
  last_login: string;
  referral_code: string | null;
  u_id: string;
  expire_on: string;
  status: string;
  mechanic_docs: {
    aadhar_front: string | null;
    aadhar_back: string | null;
    pan: string | null;
    DL: string | null;
    passbook: string | null;
    shop_photo: string | null;
    agreement: string | null;
  };
  insert_dt: string;
  address: string;
  agreed_amount: number;
  extra_amount: number;
  mechanic_shift: string;
  contact_no: string;
  mechanic_type: string;
  rsa_mechanic: string;
  sow_mechanic: string;
  towing_mechanic: string;
  city: string;
  nodal: string;
  nodal_v: string;
  latitude: string;
  longitude: string;
  location: string;
  branch_office: string;
  payout_type: string;
  pin: string;
  state: string;
  total_services_done: number;
  total_earned_amount: number | null;
}

export interface IMechanicFilters {
  dateRange: string;
  shift: string;
  type: string;
  rsaSow: string;
  searchBy: string;
  searchQuery: string;
}

export interface IMechanicListState {
  list: IMechanic[];
  totalRecords: number;
  loading: boolean;
  filters: IMechanicFilters;
}

export const FETCH_MECHANIC_LIST_PROGRESS = "FETCH_MECHANIC_LIST_PROGRESS";
export const FETCH_MECHANIC_LIST_SUCCESS = "FETCH_MECHANIC_LIST_SUCCESS";
export const FETCH_MECHANIC_LIST_FAILED = "FETCH_MECHANIC_LIST_FAILED";
export const UPSERT_MECHANIC_SUCCESS = "UPSERT_MECHANIC_SUCCESS";
export const SET_MECHANIC_LIST_FILTERS = "SET_MECHANIC_LIST_FILTERS";

export const MECHANIC_LIST_CSV_HEADERS = [
  "ID",
  "Name",
  "Mobile Number",
  "Nodal Name",
  "Mechanic Shift",
  "Mechanic Type",
  "RSA Mechanic",
  "Sow Mechanic",
  "Towing Mechanic",
  "Agreed Amount",
  "Extra Amount",
  "Created By",
  "Joined Date",
  "City",
  "State",
  "Total Services Done",
  "Total Earning",
];

